import React, { useContext } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Form } from "reactstrap";
import { FaTimes } from "react-icons/fa";
import InputField from "./InputField";
import SelectInputField from "./SelectInputField";
import { SettingGeneralContext, SettingGeneralProvider } from "../../context/settingGeneralContext";

export default function ModalContentReusable({
    isOpen,
    isClose,
    handleSubmit,
    handleChange,
    fields = [],
    title,
    children,
    size = "lg",
}) {
    return (
        <SettingGeneralProvider>
            <ModalContentReusableContent
                isOpen={isOpen}
                isClose={isClose}
                handleSubmit={handleSubmit}
                handleChange={handleChange}
                fields={fields}
                title={title}
                children={children}
                size={size}
            />
        </SettingGeneralProvider>
    );
}

function ModalContentReusableContent({
    isOpen,
    isClose,
    title,
    size,
    children
}) {
    const { state } = useContext(SettingGeneralContext);
    const appSidebarColor1 = state?.showTheme?.app_sidebar_color_1 ?? "#29B8FF";

    return (
        <Modal show={isOpen} onHide={isClose} size={size} centered>
            <div style={{ width: "100%", display: "flex", padding: "10px 0px", backgroundColor: appSidebarColor1 }}>
                <div style={{ flex: "92%", fontSize: "20px", paddingLeft: "10px", color: "white", fontWeight: "600" }}>
                    {title}
                </div>
                <div style={{ flex: "8%", fontSize: "30px", display: "flex", justifyContent: "center", color: "white" }}>
                    <FaTimes onClick={isClose} style={{ cursor: "pointer" }} />
                </div>
            </div>
            <Modal.Body>
                {children}
            </Modal.Body>
        </Modal>
    );
}
